
// Fix: Ensure modular imports are correct for Firebase v9+ by using @firebase scoped packages
import { initializeApp } from "@firebase/app";
import { getAnalytics, isSupported } from "@firebase/analytics";
import { getAuth, GoogleAuthProvider } from "@firebase/auth";
import { getFirestore } from "@firebase/firestore";
import { getFunctions } from "@firebase/functions";

// Configuração do Firebase
const firebaseConfig = {
  apiKey: "AIzaSyCcqcJLNwV3yPoyT-ZMpqgPr6CwLKHFv_g",
  authDomain: "app-minha-obra-16630.firebaseapp.com",
  projectId: "app-minha-obra-16630",
  storageBucket: "app-minha-obra-16630.firebasestorage.app",
  messagingSenderId: "575689298512",
  appId: "1:575689298512:web:8853733f7fd7b981bff755",
  measurementId: "G-5KWZQ64PXZ"
};

// Inicialização correta e limpa do Firebase App
const app = initializeApp(firebaseConfig);

// Inicialização segura do Analytics
let analytics: any = null;
if (typeof window !== 'undefined') {
  isSupported().then(supported => {
    if (supported) {
      analytics = getAnalytics(app);
    }
  }).catch(() => {
    /* Analytics não suportado neste ambiente */
  });
}

// Exportação das instâncias de serviço
const auth = getAuth(app);
auth.useDeviceLanguage(); // Usa o idioma do navegador do usuário no popup

const db = getFirestore(app);
// A extensão do Stripe geralmente roda em us-central1
const functions = getFunctions(app, 'us-central1');

// Provedores de Autenticação Social
const googleProvider = new GoogleAuthProvider();

export { app, auth, db, analytics, functions, googleProvider };
